<template>
  <div>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">报表管理</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="日期范围" prop="ReportTime">
            <el-date-picker
              v-model="ReportTime"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              unlink-panels
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="上报点位">
            <el-select v-model="ReportStationId" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in ReportStationArr"
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
            <el-button @click="isSendMsgDialogVisible=true">生 成 日 报</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-radio-group v-model="radio">
            <el-radio :label="1">按日期汇总</el-radio>
            <el-radio :label="2">按点位汇总</el-radio>
          </el-radio-group>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              show-summary
              sum-text="汇总"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="ReportStationName" label="上报点位"></el-table-column>
              <el-table-column prop="ReportStartTime" label="起始时间" :formatter="formatDateTime"></el-table-column>
              <el-table-column prop="ReportEndTime" label="截止时间" :formatter="formatDateTime"></el-table-column>
              <el-table-column prop="ReportNumber" label="接待人次"></el-table-column>
              <el-table-column prop="ReportMoney" label="上报收入"></el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
    <el-dialog
      destroy-on-close="true"
      top="30vh"
      :visible.sync="isSendMsgDialogVisible"
      title="发送日报"
    >
      <SendMsgPopup :Phone="phone" @handle_close="isSendMsgDialogVisible=false"></SendMsgPopup>
    </el-dialog>
  </div>
</template>

<script>
import SendMsgPopup from "./SendMsgPopup";
import MyApis from "../../../apis";
export default {
  name: "TourReportView",
  controller: "UI",
  action: "TourReportView",
  components: {
    SendMsgPopup,
  },
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      currentPage: 1,
      pageSize: 20,
      total: 0,
      radio: 1,
      StationAndTimetableData: [],
      StationtableData: [],
      tableData: [],
      ReportTime: [new Date(), new Date()],
      ReportStationId: "",
      ReportStationArr: [],
      isSendMsgDialogVisible: false,
    };
  },
  created: function () {
    this.search();
  },
  mounted: function () {
    this.getStation();
  },
  watch: {
    radio: function () {
      if (this.radio == 1) {
        this.tableData = this.StationAndTimetableData;
      } else {
        this.tableData = this.StationtableData;
      }
    },
  },
  methods: {
    getStation() {
      this.config
        .getUValue("System.Report:System.Report.Station", "")
        .then((d) => {
          this.ReportStationArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    search() {
      let searchInfo = {
        ReportBeginDate: new Date(
          this.ReportTime[0].format("yyyy-MM-dd 00:00")
        ),
        ReportEndDate: new Date(this.ReportTime[1].format("yyyy-MM-dd 23:59")),
      };
      if (this.ReportStationId && this.ReportStationId != "") {
        searchInfo.ReportStationId = this.ReportStationId;
      }
      this.loading = true;
      this.radio = 1;
      new MyApis.TourReportResourcesApi()
        .GetDataStaticByStationAndTime(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.StationAndTimetableData = this.sortList(r, "ReportStationName");
          this.tableData = this.StationAndTimetableData;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });

      new MyApis.TourReportResourcesApi()
        .GetDataStaticByStation(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.StationtableData = r;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    sortList(list, sortName) {
      return list.sort((a, b) => {
        return a[sortName].localeCompare(b[sortName]); 
      });
    },
    // 点击查询按钮
    onSearch() {
      this.search();
    },
    clearsearch() {
      this.ReportTime = [new Date(), new Date()];
      this.ReportStationId = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd");
    },
    formatDateTime(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
  },
};
</script>

